import { GeoData, SET_GEO_ERROR, SET_GEO_LOADING, SET_GEO_LOCATION } from "./actions";

const initialState = {
  geo: {
    data: null as GeoData | null,
    loading: false,
    error: null as string | null,
  },
};

interface Action {
  type: string;
  useragent?: string;
  navigator?: { userAgent: string };
  payload?: any;
}

export default function (state = initialState, action: Action = { type: "" }) {
  switch (action.type) {
    case SET_GEO_LOCATION: {
      return {
        ...state,
        geo: {
          ...state.geo,
          data: action.payload,
          error: null,
        },
      };
    }
    case SET_GEO_LOADING: {
      return {
        ...state,
        geo: {
          ...state.geo,
          loading: action.payload,
        },
      };
    }
    case SET_GEO_ERROR: {
      return {
        ...state,
        geo: {
          ...state.geo,
          error: action.payload,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
}
